// Interfaces
import { IRoute } from 'routes/route.interface'

// Profile
import { personalDataRoutes } from './personal-data'

// User Management
import { userRoutes } from './user'

// User Access
import { userAccessRoutes } from './user-access'

// Content Management
import { contentRoutes } from './content-management'

// Q&A
import { qaRoutes } from './qa'

// Master
import { masterRoutes } from './master'

// Assessment
import { assessmentRoutes } from './assessment'

const backOfficeParentRoutes = [
  personalDataRoutes,
  assessmentRoutes,
  userRoutes,
  userAccessRoutes,
  contentRoutes,
  qaRoutes,
  masterRoutes,
]

// Map Back Office Parent Routes
const backOfficeChildrenRoutes: IRoute[] = []
backOfficeParentRoutes.forEach(parentRoute => {
  backOfficeChildrenRoutes.push(...parentRoute.children)
})

export { backOfficeChildrenRoutes, backOfficeParentRoutes }